import React from "react";
import DeductionGenericSkeleton from "./DeductionGenericSkeleton";

function DeductionDetailSkeleton() {
  return (
    <>
      <DeductionGenericSkeleton />
    </>
  );
}

export default DeductionDetailSkeleton;
